import { createContext, useContext } from 'react'

export const WidgetCustomPayloadContext = createContext<
  Record<string, any> | undefined
>(undefined)

export const useWidgetCustomPayload = () =>
  useContext(WidgetCustomPayloadContext)
